import React from 'react'
import {Link as RouterLink, useMatch} from "react-router-dom";
import {Button} from "@mui/material";

export default function KirbyNavigationButton (props:{url:string, copy:string, onClick?():void}){
  const match = useMatch(props.url);
  return <Button variant={"main"} className={(match && "active") ?? ""} component={RouterLink} to={props.url} onClick={props.onClick}>{props.copy}</Button>
}
